// extracted by mini-css-extract-plugin
export default {"melodyVideo":"fQ-z","isFullWidth":"gQ-z","landingPageVideo":"hQ-z","play":"iQ-z","iframeVideo":"jQ-z","playHidden":"kQ-z","fullwidth":"lQ-z"};